// @flow
/* eslint-disable arrow-body-style */
import React, { useEffect } from 'react';
import { t } from 'javascripts/utils/withTranslation';
import LoginHandler from 'javascripts/globals/login-handler';
import IconLink from 'components/atoms/icon-link/react/IconLink';
import type { LoginProps } from '../types';

const Login = ({
  username,
  userUrl,
  loginUrl,
  logoutUrl,
  cookieName,
  listElement = true,
}: LoginProps): React$MixedElement => {
  const [loggedIn, setLoggedIn] = React.useState(false);
  const Tag = listElement ? 'li' : 'div';

  useEffect(() => {
    const loginState = LoginHandler.getLoginStateAsBoolean(cookieName);
    setLoggedIn(loginState);
  }, []);

  return (
    <>
      {loggedIn && (userUrl || logoutUrl) && (
        <>
          {userUrl && (
            <Tag className="header__login">
              <IconLink link={userUrl} icon="people-added">
                {username || t('Profil')}
              </IconLink>
            </Tag>
          )}
          {logoutUrl && (
            <Tag className="header__login">
              <IconLink link={logoutUrl} icon="arrow-box-left-line">
                {t('Abmelden')}
              </IconLink>
            </Tag>
          )}
        </>
      )}
      {!loggedIn && loginUrl && (
        <Tag className="header__login">
          <IconLink link={loginUrl} icon="arrow-box-right-line">
            {t('Anmelden')}
          </IconLink>
        </Tag>
      )}
    </>
  );
};

export default Login;
